import { Component } from '@angular/core';
import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UIBlockingService } from '../core/ui-blocking.service';
import { ToastNotificationService } from '../core/toast-notification.service';
import { PendingNewsService } from './pending-news.service';
import { merge, Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { PendingNewsInfo } from './DTOs/pending-news-info';
import { VerifyRejectRequest } from '../core/verify-reject-request';
import { UpdatePendingNewsRequest } from './DTOs/update-pending-news-request';
import { CommonLibrary } from '../core/common-library';
import { EditNewsArticleModalComponent } from './Modals/edit-news-article-modal.component';


@Component({
  selector: 'app-pending-news-article',
    templateUrl: './pending-news-article.component.html',
    providers: [UIBlockingService, NgbDropdown]

})
export class PendingNewsArticleComponent {
    constructor(private pendingNewsService: PendingNewsService
        , private blockUI: UIBlockingService
        , private notificationService: ToastNotificationService
        , private modalService: NgbModal
        , private route: ActivatedRoute
        , private router: Router) { }

    protected readonly CommonLibrary = CommonLibrary;
    newsInfo: PendingNewsInfo;

    ngOnInit() {
        this.newsInfo = new PendingNewsInfo();
        this.getPendingNewsInfo()
    }

    getPendingNewsInfo() {
        this.blockUI.start();
        this.pendingNewsService.getPendingNewsInfo(parseInt(this.route.snapshot.paramMap.get("id"))).subscribe({
            next: (data) => {
                this.newsInfo = data;
                if (this.newsInfo.mainImageUrl == "") this.newsInfo.mainImageUrl = "../../assets/images/member_news_default.png";
            },
            error: (err) => {
                this.notificationService.error(err.error.message);
                this.blockUI.stop();
                console.log(err)
            },
            complete: () => {
                this.blockUI.stop();
            }
        });
    }

    openEditModal() {
        const modalRef = this.modalService.open(EditNewsArticleModalComponent, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.newsInfo = this.newsInfo;
        modalRef.result.then(response => {
            this.getPendingNewsInfo();
        })
            .catch(err => {
            });
    }

    PublishArticle(status: number) {
        const req = new VerifyRejectRequest(this.newsInfo.newsId.toString(), this.newsInfo.approverNotes);
        this.pendingNewsService.changeNewsStatus(req, status).subscribe({
            next: (data) => {
            },
            error: (err) => {
                this.blockUI.stop();
                this.notificationService.error(err.error.message);
                console.log(err)
            },
            complete: () => {
                this.blockUI.stop();
                this.router.navigate(['/admin-portal/chamber/pending-news/']);
            }
        });
    }

    DownloadAttachment(ind) {
        CommonLibrary.downloadImageByUrl(this.newsInfo.attachmentInfo[ind].downloadUrl, this.newsInfo.attachmentInfo[ind].name.split('.')[0])
    }
}
